import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const COLS = [
  {
    title: "Products",
    links: [
      ["Food Service", "/category/food-service"],
      ["Packaging Supplies", "/category/packaging-supplies"],
      ["Cleaning Equipment", "/category/cleaning-equipment"],
      ["Chemical Hygiene", "/category/chemical-hygiene"],
      ["Paper Hygiene", "/category/paper-hygiene"],
      ["All Products", "/products"],
    ],
  },
  {
    title: "Industries",
    links: [
      ["Cafés & Restaurants", "/industries"],
      ["Supermarkets & Grocery", "/industries"],
      ["Manufacturing", "/industries"],
      ["Healthcare & Aged Care", "/industries"],
      ["Hospitality & Events", "/industries"],
    ],
  },
  {
    title: "Customer Service",
    links: [
      ["Request a Quote", "/contact"],
      ["Bulk Pricing", "/contact"],
      ["Delivery Info", "/contact"],
      ["Returns", "/contact"],
      ["FAQs", "/contact"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About Us", "/about"],
      ["Sustainability", "/about"],
      ["Contact", "/contact"],
      ["Trade Account", "/trade-account"],
    ],
  },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-vr-navy text-white">
    <div className="max-w-[1500px] mx-auto px-6 md:px-10 pt-16 pb-10">
      <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-white/10">
        <div className="md:col-span-3">
          <div className="inline-flex bg-white rounded-xl px-4 py-3">
            <img src="/vr-logo.jpg" alt="VR Packaging & Hygiene" className="h-9 w-auto" />
          </div>
          <p className="mt-5 text-white/60 text-sm leading-relaxed max-w-xs">
            New Zealand's single supplier for packaging, hygiene, cleaning and safety. Wholesale pricing, nationwide delivery.
          </p>
        </div>

        {COLS.map((col) => (
          <div key={col.title} className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.15em] text-white/40 mb-5">{col.title}</div>
            <ul className="space-y-3 text-sm text-white/70">
              {col.links.map(([label, to]) => (
                <li key={label + to}>
                  <Link to={to} className="hover:text-white transition-colors">{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="md:col-span-1 min-w-[200px]">
          <div className="text-xs uppercase tracking-[0.15em] text-white/40 mb-5">Contact</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="text-white font-semibold">Sales &amp; Enquiries</li>
            <li><a href="tel:+64221598639" className="flex items-center gap-2 hover:text-white transition-colors"><Phone size={14} /> +64 22 159 8639</a></li>
            <li><a href="mailto:sales@vrpackaging.co.nz" className="flex items-center gap-2 hover:text-white transition-colors"><Mail size={14} /> sales@vrpackaging.co.nz</a></li>
            <li><a href="mailto:accounts@vrpackaging.co.nz" className="flex items-center gap-2 hover:text-white transition-colors"><Mail size={14} /> accounts@vrpackaging.co.nz</a></li>
            <li className="flex items-start gap-2"><MapPin size={14} className="mt-0.5 shrink-0" /> 14 Tony Segedin Drive, Avondale, Auckland 1026</li>
          </ul>
        </div>
      </div>

      <div className="pt-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/45">
        <span>© {new Date().getFullYear()} VR Packaging & Hygiene Ltd · vrpackaging.co.nz</span>
        <span>Wholesale Packaging & Hygiene · New Zealand</span>
      </div>
    </div>
  </footer>
);
